import { TOrderPriority, TShipmentType } from 'constants/types';
import { IAutoMessage } from './Auto/AutoTablePart';
import { IHistoryTableDataAuto } from './History/components/table/HistoryTable';
import { IResponseGetMessageAuto, IResponseGetMessageManualHistory, IResponseGetMessageAutoHistory } from './api';
import { IManualMessage } from './Manual/ManualTable';
import { IMultiSkillData } from 'types/masterData/multiSkill';

//// 알림메시지 자동설정 테이블 데이터
export const dtoAutoMessage = (res: IResponseGetMessageAuto[]): IAutoMessage[] => {
  return res.map((data, index) => {
    return {
      code: data.code ? data.code.toString() : '',
      status: data.status === 1 ? true : false,
      receiver: data.receiver as 'driver' | 'client',
      process: data.process ? data.process.toString() : '',
      title: data.title ? data.title : '',
      trigger: data.trigger ? data.trigger : '',
      contents: data.contents ? data.contents : '',
      disabledSendTime: data.disabledSendTime === 1 ? true : false,
      sendStartTime: data.sendStartTime ? data.sendStartTime : '',
      sendEndTime: data.sendEndTime ? data.sendEndTime : '',
      createdAt: data.createdAt ? data.createdAt : '',
      updatedAt: data.updatedAt ? data.updatedAt : '',
      createdBy: data.createdBy ? data.createdBy : '',
      updatedBy: data.updatedBy ? data.updatedBy : '',
      processStatus: data.processStatus ? data.processStatus : '',
    };
  });
};

//// 발송이력조회
// > 수동(예약)발송 테이블 데이터
export const dtoManualHistory = (res: IResponseGetMessageManualHistory[]): IHistoryTableDataAuto[] => {
  return res.map((data, index) => {
    let recipantName = '';
    if (data?.messageReceivers && data?.messageReceivers.length > 0) {
      if (data?.messageReceivers.length > 1) {
        recipantName = `${data.messageReceivers[0].consigneeName} 외 ${data.messageReceivers.length - 1}명`;
      } else {
        recipantName = data.messageReceivers[0].consigneeName ? data.messageReceivers[0].consigneeName : '';
      }
    }
    return {
      messageId: data.messageId ? data.messageId.toString() : '',
      sendDate: data.reserveDatetime ? data.reserveDatetime : '',
      title: data.messageTitle ? data.messageTitle : '',
      recipant_name: recipantName,
      contents: data.messageContents ? data.messageContents : '',
      recipent_infos: data.messageReceivers.map(receiver => {
        return {
          customer_name: receiver.consigneeName ? receiver.consigneeName : '',
          customer_phone: receiver.consigneePhone ? receiver.consigneePhone : '',
          messageReceiverId: receiver.messageReceiverId ? receiver.messageReceiverId : null,
          messageId: receiver.messageId ? receiver.messageId : null,
          createdAt: receiver.createdAt ? receiver.createdAt : '',
        };
      }),
      send_status: typeof data.sendStatus === 'string' ? data.sendStatus : '',
      teamId: data.teamId ? data.teamId : null,
      requestId: data.requestId ? data.requestId : null,
      createdBy: data.createdBy ? data.createdBy : '',
      updatedAt: data.updatedAt ? data.updatedAt : '',
      createdAt: data.createdAt ? data.createdAt : '',
      updatedBy: data.updatedBy ? data.updatedBy : '',
      sendMode: data.sendMode ? data.sendMode : false,
    };
  });
};

// > 자동발송/발송제외 테이블 데이터
export const dtoAutoHistory = (res: IResponseGetMessageAutoHistory[]): IHistoryTableDataAuto[] => {
  return res.map((data, index) => {
    return {
      messageId: data.messageAutoHistoryId ? data.messageAutoHistoryId.toString() : '',
      sendDate: data.createdAt ? data.createdAt : '',
      recipentType: data.receiverType ? data.receiverType : '',
      title: data.messageTitle ? data.messageTitle : '',
      contents: data.messageContents ? data.messageContents : '',
      recipant_name: data.receiverName ? data.receiverName : '',
      recipent_infos: [
        {
          customer_name: data.receiverName ? data.receiverName : '',
          customer_phone: data.receiverPhone ? data.receiverPhone : '',
        },
      ],
      exceptionEndTime: data.exceptionEndTime ? data.exceptionEndTime : '',
      exceptionStartTime: data.exceptionStartTime ? data.exceptionStartTime : '',
    };
  });
};

//// 메시지 수동 발송
export const dtoMessageManualList = (res: IResponseOrdersList[]): IManualMessage[] => {
  return res.map(item => {
    let itemCount = 0,
      itemName = '';
    if (item?.product && item.product.length > 0) {
      if (item.product.length === 1) {
        itemCount = item.product[0].quantity ? item.product[0].quantity : 0;
        itemName = item.product[0].name ? item.product[0].name : '';
      } else {
        let itemMainName = item.product[0].name ? item.product[0].name : '';
        let itemSubName = item.product.length - 1 > 0 ? `${item.product.length - 1}` : '';
        itemName = `${itemMainName} 외 ${itemSubName}건`;
        itemCount = item.product.map(product => product.quantity ?? 0).reduce((acc, cur) => (acc ?? 0) + (cur ?? 0), 0);
      }
    }
    return {
      order_id: item.orderCode ? item.orderCode : '', // 주문ID
      order_status: item.status ? item.status : '', // 주문상태 'completed' | 'skipped' | 'pending'
      customer_name: item.consigneeName ? item.consigneeName : '', // 고객명
      customer_phone: item.consigneePhone ? item.consigneePhone : '', // 고객연락처
      driver_name: item.driverName ? item.driverName : '', // 담당기사님
      company_order_id: item.clientKey ? item.clientKey : '', // 회사주문번호
      order_date: item.receivedDate ? item.receivedDate : '', // 주문접수일
      address: item.address ? item.address : '', // 주소
      detail_address: item.detailAddress ? item.detailAddress : '', // 상세주소
      item_name: itemName, // 상품명
      item_count: itemCount, // 상품수량
      // 추가 처리
      desiredDate: item.desiredDate ? item.desiredDate : '', // 작업희망일
      shipmentType: item.shipmentType ? item.shipmentType : '', // 주문 유형 'delivery' | 'pickup'
      priority: item.priority ? item.priority : '', // 배차 우선순위 'high' | 'normal' | 'low'
      serviceVehicle: item.serviceVehicle ? item.serviceVehicle : '', // 담당 드라이버 지정
      desiredTimeEnd: item.desiredTimeEnd ? item.desiredTimeEnd : '', // 희망 시간(이전)
      desiredTimeStart: item.desiredTimeStart ? item.desiredTimeStart : '', // 희망 시간(이후)
      capacity: item.capacity ? item.capacity : 0, // 예상 용적량
      skills: item.skills ? item.skills.map(skill => ({ ...skill, team: { teamId: 0, name: '' }, drivers: [] })) : [], // 특수 조건
      serviceTime: item.serviceTime ? item.serviceTime : 0, // 예상 작업 소요 시간 (분)
      actualServiceTime: item.actualServiceTime ? item.actualServiceTime : 0, // 실제 작업 소요 시간 (분)
      completedAt: item.completedAt ? item.completedAt : '', // 작업 완료 일시
      skippedComment: item.skippedComment ? item.skippedComment : '', // 보류 사유
      skippedAt: item.skippedAt ? item.skippedAt : '', // 보류 일시
      consigneeNote: item.consigneeNote ? item.consigneeNote : '', // 고객전달사항
      note: item.note ? item.note : [], // 비고1~5
    };
  });
};

export interface IResponseOrdersList {
  actualServiceTime?: number; // ?? 실제 작업 소요 시간 (분)
  address: string; // 주소 / 8번
  clientKey: string; // 회사주문번호 6번
  capacity: number; // ?? / 예상 용적량
  completedAt: string | null; // ?? 작업 완료 일시
  consigneeName: string | null; // 수취인 이름 / 고객명 / 3번
  consigneeNote: string | null; // ?? 고객전달사항
  consigneePhone: string | null; // 수취인 전화번호 / 고객연락처 / 4번
  desiredDate: string | null; // ?? '10:00' /  작업희망일
  desiredTimeEnd: string | null; // ?? '12:00' / 희망 시간(이전)
  desiredTimeStart: null; // ?? '10:00' / 희망 시간(이후)
  detailAddress: string | null; // 상세주소 / 9번
  driverName: string | null; // 담당기사님 / 5번
  note: string[] | null; // 비고1~5
  orderCode: string | null; // 주문ID 1번
  orderId: number | null; // 주문ID(이건 아님)
  orderPod: {
    capacity?: number;
    comment?: string;
    orderPodFiles: {
      s3url: string;
      createdAt: string;
    }[];
  } | null; //
  priority: TOrderPriority | null; // 우선순위 'high' | 'normal' | 'low'
  product: // 상품명 , 상품수향 / 10, 11번
  | {
        code?: string;
        name?: string;
        quantity?: number;
      }[]
    | null;
  receivedDate: string | null; // '2021-07-01' 주문접수일 / 7번
  serviceTime: number | null; // ?? 예상 작업 소요 시간 (분)
  serviceVehicle: string | null; // ?? 담당 드러이버 지정
  shipmentType: TShipmentType | null; // 'delivery' | 'pickup' / 주문 유형
  skills: Pick<IMultiSkillData, 'skillId' | 'name'>[] | null; // 특수 조건
  skippedAt: string | null; // 보류 일시
  skippedComment: string | null; // 보류 사유
  status: string | null; // 주문상태 2번
}
